import React, { ReactNode, useState } from 'react'
import { useCurrentSociety } from '../../../hooks/useCurrentSociety'
import { SpinnerWrapper } from '../../common/SpinnerWrapper'
import { PremiumSection } from './PremiumSection'
import { AccordionSection } from '../../common/AccordionSection'
import { useAccordionSections } from './useAccordionSections'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import { BasicSection } from './BasicSection'
import { PaymentModal } from './PaymentModal'
import { useModal } from '../../../hooks/useModal'
import { DiscountModal } from './DiscountModal'
import { SocietyTypes } from '../../../types/society-type'
import { Illustration, IllustrationChoices } from '../../common/Illustration'
import { theme } from '../../../theme/theme'
import GettingStarted from '../GettingStarted/GettingStarted'

export const PaymentDetails = (): ReactNode => {
  const { society, isLoading } = useCurrentSociety()
  const { translate } = useAppTranslation()
  const [discountCode, setDiscountCode] = useState('')
  const accordionSectionItems = useAccordionSections(society)

  const billingEmail = society?.billingEmail
  const {
    show: showPaymentModal,
    open: openPaymentModal,
    close: closePaymentModal,
  } = useModal()
  const {
    show: showDiscountCodeModal,
    open: openDiscountCodeModal,
    close: closeDiscountCodeModal,
  } = useModal()

  if (isLoading) {
    return <SpinnerWrapper />
  }

  if (!society) return null

  const isNeighbourhood =
    society?.societyTypeDisplayName === SocietyTypes.NEIGHBOURHOOD

  return (
    <>
      <div className="w-full">
        <GettingStarted
          className="mb-4"
          title={translate(`gettingStartedScreen.screens.billing.title`)}
          description={translate(
            `gettingStartedScreen.screens.billing.description`
          )}
          gettingStartedId="billing"
          hideCompleteButton
        />
        {!isNeighbourhood ? (
          <>
            {society?.accountType === 'premium' ? (
              <PremiumSection
                society={society}
                openDiscountCodeModal={openDiscountCodeModal}
              />
            ) : (
              <BasicSection
                openPaymentModal={openPaymentModal}
                openDiscountCodeModal={openDiscountCodeModal}
                billingEmail={billingEmail}
                society={society}
              />
            )}
          </>
        ) : (
          <div className="flex items-center gap-6">
            <Illustration
              illustrationChoice={IllustrationChoices.SUN}
              width={100}
            />
            <p style={theme.textVariants.lead}>
              {translate('invoiceView.neighbourhood.title')}
            </p>
          </div>
        )}
        <AccordionSection
          className="mt-10"
          title={translate('invoiceView.accordions.title')}
          items={accordionSectionItems}
        />
      </div>
      <PaymentModal
        society={society}
        show={showPaymentModal}
        close={closePaymentModal}
        discountCode={discountCode}
      />
      <DiscountModal
        show={showDiscountCodeModal}
        openPaymentModal={openPaymentModal}
        setDiscountCode={(code) => setDiscountCode(code)}
        close={closeDiscountCodeModal}
        society={society}
      />
    </>
  )
}
